import { render, staticRenderFns } from "./RecipientListMenu.vue?vue&type=template&id=adf2f046"
import script from "./RecipientListMenu.vue?vue&type=script&lang=js"
export * from "./RecipientListMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports